export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const navHeight = 80; // Hauteur de la navigation (h-20 = 80px)
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - navHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://static.readdy.ai/image/a16a140b1ca96878839a6d35b91aba7d/b7ff4fdda512176d93f7cfe999b56c95.jpeg"
          alt="Vision OTOROBOTS"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-20">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-serif text-white leading-tight mb-6 sm:mb-8">
          Là où les systèmes intelligents
          <br className="hidden sm:block" />
          servent l'humain
        </h1>

        <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-light text-white/95 mb-10 sm:mb-12 max-w-3xl mx-auto leading-relaxed px-4">
          OTOROBOTS CANADA INC. conçoit, structure et soutient des systèmes technologiques, humains et organisationnels qui permettent aux individus, aux projets et aux organisations de se développer de façon cohérente, responsable et alignée.
        </p>

        <button
          onClick={() => scrollToSection('qui-sommes-nous')}
          className="inline-block px-8 sm:px-10 py-3 sm:py-4 bg-white text-gray-900 text-sm sm:text-base font-medium rounded-full hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap shadow-lg"
        >
          Découvrir notre vision
        </button>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 sm:bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl sm:text-3xl text-white/80"></i>
      </div>
    </section>
  );
}
